<style scoped>
  .selected { font-weight: bold }
  li { cursor: pointer }
</style>

<template>
  <div class="col-12 similarsBlock sizeDropBlock">
    <span class="attr-title" v-html="`${similarGroup.similarGroupName}`"></span>
    <button class="selectDropSize" v-on:click="visible = !visible">{{ getSelectedText || t('selection') }}
      <i class="lni lni-chevron-down"></i>
    </button>
    <div v-show="visible" class="toggleAttrsBlk">
      <ul>
        <li v-for="similarEntry in getSimilarEntriesOfThisGroupFromSimilarGroupData"
            :key="similarEntry.similarId"
            v-on:click="navigateToProduct(similarEntry.similarId)"
            :class="getSimilarTextClass(defaultValue, similarEntry)">
          {{ similarEntry.similarName }}
          <span v-if="getSimilarOutOfStock(similarEntry)" class="similar-not-available">
            ( {{ t('product_status.unavailable.text') }} )
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import similarSelectorMixin from '../mixins/similarSelectorMixin'

export default {
  name: 'SimilarTextSelector',
  mixins: [similarSelectorMixin],
  data () {
    return {
      version: '0.0.2',
      visible: false
    }
  },
  created () {
    window.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.visible = false
      }
    })
  },
  methods: {
    getSimilarOutOfStock (similar) {
      return similar.stock <= 0
    },
    getSimilarTextClass (defaultValue, similar) {
      if (defaultValue === similar.similarName) {
        return 'selected'
      } else if (this.getSimilarOutOfStock(similar)) {
        return 'disabled'
      }
      return ''
    }
  }
}
</script>
